import { type CONTENT_STATUS, CONTENT_STATUS_KO } from '@mathflat/domain/@entities/(Content)/module'
import clsx from 'clsx'
import type { ValueOf } from 'type-fest'

export const StatusTag = ({
  contentStatus,
}: {
  contentStatus: ValueOf<typeof CONTENT_STATUS> | 'IMPOSSIBLE'
}) => {
  return (
    <span className={clsx('tag', contentStatus)}>
      {contentStatus === 'IMPOSSIBLE' ? '응시불가' : CONTENT_STATUS_KO[contentStatus]}
    </span>
  )
}
